import type {ComponentPropsWithRef} from 'react';
import styles from './anchor-button.module.css';

type AnchorButtonProps = {
  readonly variant?: 'fill' | 'flat' | 'outlined' | 'text';
  readonly color?: 'primary' | 'secondary' | 'danger';
  readonly size?: 'medium' | 'large';
} & ComponentPropsWithRef<'a'>;

export function AnchorButton({
  variant = 'fill',
  color = 'primary',
  size = 'medium',
  children,
  ...props
}: AnchorButtonProps) {
  return (
    <a
      className={styles.button}
      data-variant={variant}
      data-color={color}
      data-size={size}
      {...props}
      rel='noreferrer'
    >
      {children}
    </a>
  );
}
